import { format } from 'date-fns'
import 'reflect-metadata'

import { plainToInstance } from 'class-transformer'
import { IsArray, IsNotEmpty, IsString } from 'class-validator'

export interface IAgreoRealTime {
  CODE_PARCELLE: string
  APPORT: string
  CPT_RECEPTION: string
  ESPECE: string
  EXPLOITATION: string
  CHANTIER: string
  USINE: string
  QUANTITE: string
  QUALITE: string
  DD_RECOLTE: string
  ARRIVE_CHAMPS: string
  DEPART_CHAMPS: string
  DATE_RECEPTION: string
  DEPART_USINE: string
  POIDS_NET: string
  CODE_RECEPTION_EXT: string
}

export class AgreoRealTime {
  plotCode: string | null = null
  job: string | null = null
  count: string | null = null
  species: string | null = null
  exploitation: string | null = null
  site: string | null = null
  factory: string | null = null
  stockKey: string | null | undefined = null
  quantity: number | null = null
  quality: string | null = null
  startWork: string | null = null
  checkInSite: string | null = null
  checkOutSite: string | null = null
  checkInFactory: string | null = null
  checkOutFactory: string | null = null
  truckWeightLeave: number | null = null
  lotNumber: string | null = null

  constructor(config: Record<string, string | number | Date | null> = {}) {
    const keysMap: Record<string, string> = {
      CODE_PARCELLE: 'plotCode',
      APPORT: 'job',
      CPT_RECEPTION: 'count',
      ESPECE: 'species',
      EXPLOITATION: 'exploitation',
      CHANTIER: 'site',
      USINE: 'factory',
      QUANTITE: 'quantity',
      QUALITE: 'quality',
      DD_RECOLTE: 'startWork',
      ARRIVE_CHAMPS: 'checkInSite',
      DEPART_CHAMPS: 'checkOutSite',
      DATE_RECEPTION: 'checkInFactory',
      DEPART_USINE: 'checkOutFactory',
      POIDS_NET: 'truckWeightLeave',
      CODE_RECEPTION_EXT: 'lotNumber',
    }

    for (const prop of Object.keys(config)) {
      if (config[prop] instanceof Date) {
        config[prop] = format(config[prop], 'yyyy-MM-dd HH:mm:ss')
      }
      if (prop === 'POIDS_NET' && config[prop] !== null) {
        config[prop] = parseFloat(String(config[prop])) / 1000
      }
      const newKey: string = keysMap[prop]
      ;(this as Record<string, unknown>)[newKey] = config[prop]
    }
  }
}

export class AgreoRealTimeByLot {
  offerId: number
  lotId: number
  realtime: AgreoRealTime

  constructor(AgreoRealTimeByLot: AgreoRealTimeByLot) {
    this.offerId = AgreoRealTimeByLot?.offerId ?? null
    this.lotId = AgreoRealTimeByLot?.lotId ?? null
    this.realtime = AgreoRealTimeByLot?.realtime ?? null
  }
}

export class SaveAgreoRealTime {
  public static build(raw: any) {
    return plainToInstance(SaveAgreoRealTime, raw)
  }

  @IsArray()
  @IsNotEmpty()
  @IsString({ each: true })
  plot!: string[]

  @IsString()
  @IsNotEmpty()
  cropType!: string
}
